import React from 'react';
import { useLocation } from 'react-router-dom';
import HeaderUnified from './HeaderUnified';
import Footer from './Footer';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { RevealManager, BackToTop } from '../ui/ScrollEffects';

/**
 * 🎯 LAYOUT WRAPPER
 * =================
 * Toutes les pages partagent le même en-tête et le même pied de page (site, espace personnel,
 * administration, pages légales). Seules les pages de connexion / inscription sont affichées
 * en plein écran, sans menu, pour rester concentrées sur le formulaire.
 */

// Pages d'authentification : affichage plein écran (elles ont leur propre mise en page)
const AUTH_ROUTES = [
  '/login',
  '/register',
  '/signup',
  '/confirm-email',
  '/forgot-password',
  '/reset-password'
];

const LayoutWrapper = ({ children }) => {
  const location = useLocation();

  const isAuthRoute = AUTH_ROUTES.some(route => location.pathname.startsWith(route));

  if (isAuthRoute) {
    return (
      <>
        {children}
      </>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <HeaderUnified />

      {/* Fil d'Ariane */}
      <Breadcrumbs className="bg-gray-50 border-b py-2 px-4" />

      <main id="contenu" className="flex-grow">
        {children}
      </main>

      <Footer />

      {/* Apparition douce des sections au défilement et bouton « Revenir en haut » (src/components/ui/ScrollEffects.js) */}
      <RevealManager />
      <BackToTop />
    </div>
  );
};

export default LayoutWrapper;
